import { justifySpaceBetween } from 'styles/mixins';

export default () => ({
  footerButtons: {
    ...justifySpaceBetween,
    alignItems: 'flex-end',
  },
});
